
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import { IntlProvider } from 'react-intl';
import messages_en from './translations/en.json'; // English translations
import messages_pt from './translations/pt-PT.json'; // Portuguese translations

const locale = navigator.language || 'pt-PT';

const messages = {
  'en': messages_en,
  'pt-PT': messages_pt,
}[locale] || messages_pt;



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>  
        <IntlProvider locale={locale} messages={messages} >
    <BrowserRouter>
      <App />  
    </BrowserRouter>
    </IntlProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
